import { render, staticRenderFns } from "./BalanceComponent.vue?vue&type=template&id=7d4797c4&scoped=true"
import script from "./BalanceComponent.vue?vue&type=script&lang=js"
export * from "./BalanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4797c4",
  null
  
)

export default component.exports